var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSpotifyWhite = function SvgSpotifyWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "spotify-white",
    d: "M215.105,468.455c-3.04-1.8-8.122-1.995-11.02-1.092a.871.871,0,0,1-.523-1.663c3.373-1,8.93-.808,12.445,1.283a.918.918,0,0,1,.333,1.235,1,1,0,0,1-1.235.237m-.1,2.66a.716.716,0,0,1-1,.237,12.313,12.313,0,0,0-9.453-1.092.721.721,0,1,1-.427-1.378,13.9,13.9,0,0,1,10.688,1.283.671.671,0,0,1,.19.95m-1.14,2.613a.565.565,0,0,1-.807.19c-2.232-1.378-5.035-1.663-8.36-.9a.588.588,0,1,1-.285-1.14c3.61-.808,6.745-.475,9.215,1.045a.569.569,0,0,1,.238.807M209.5,460a9.5,9.5,0,1,0,9.5,9.5,9.528,9.528,0,0,0-9.5-9.5",
    transform: "translate(-200 -460)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpotifyWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spotify-white.8fa755dc.svg";
export { ForwardRef as ReactComponent };